export default __webpack_public_path__ + "static/media/04.94c465ae.png";